import { computed, observable } from "mobx";
import { observer } from "mobx-react";
import * as React from "react";
import * as DocumentReader from "../DocumentReader";
import { ActivePortalIcon } from "../Icons/ActivePortalIcon";
import { LogInComponent } from "../LogInComponent";
import * as PortalManagement from "../PortalManagement";
import { AppStore } from "../Stores/AppStore";
import { DialogStore } from "../Stores/DialogStore";
import { NotificationStore } from "../Stores/NotificationStore";
import { Strings } from "../Stores/StringsStore";
import { Urls } from "../Urls";
import { SyncStatus } from "./SyncStatus";

@observer
export class Head extends React.Component<{}, {}> {

	@observable isLocal: boolean = true;

	componentDidMount() {
		AppStore.setTitle(AppStore.context.applicationTitle);
		if (AppStore.context.sessionDetails.isApp) {
			this.isLocal = AppStore.context.portalSettings.id === "";
			this.getAllPortalSettings();
		}
	}

	componentDidUpdate() {
		AppStore.setTitle(AppStore.context.applicationTitle);
	}

	getAllPortalSettings(): void {
		AppStore.updatePortals().then(() => {
			NotificationStore.clearMessage();
		}).catch(error => DialogStore.showError(Strings.general.errorDialogTitle, error));
	}

	switchPortal = (event: React.MouseEvent<any>) => {
		event.preventDefault();
		let portalSettingsID = (event.target as any).id as string;
		this.isLocal = portalSettingsID === "";
		PortalManagement.setCurrentPortalSettingsAsync(portalSettingsID).then(portalSettings => {
			AppStore.init().then(() => {
				AppStore.history.replace("/");
				location.reload(true);
				DocumentReader.restoreDownloadedFilesAsync()
					.catch(error => DialogStore.showError(Strings.general.errorDialogTitle, error));
			}).catch(error => DialogStore.showError(Strings.general.errorDialogTitle, error));
		}).catch(error => DialogStore.showError(Strings.general.errorDialogTitle, error));
	}

	@computed get headerLogoCSS() {
		return AppStore.context.sessionDetails.isApp ? "app__head-logo-wrapper is--portal-switch" : "app__head-logo-wrapper";
	}

	render() {
		return <div className="app__head">
			<div className="app__head-logo">
				<div className={this.headerLogoCSS}>

					<img src={Urls.titleBarLogo} alt="" />
					<span>{AppStore.context.applicationTitle}</span>

					{
						AppStore.context.sessionDetails.isApp ?
							<div className="portal-switch">

								<ul>
									{
										AppStore.portals.map((portal) => {
											return <li key={"portalSettings-" + portal.id}><a id={portal.id} href="#" onClick={this.switchPortal}>
												{portal.name}
												<span className="portal-switch__additional">
													{portal.isCurrent ? <ActivePortalIcon /> : null}
												</span>
											</a></li>;
										})
									}
								</ul>
							</div> : null
					}
				</div>
			</div>
			<LogInComponent testId="logInButton" />

		</div>;
	}
}
